/**
 * PWAUpdatePrompt — toast-style banner shown when a new SW version is ready.
 * Wire into App.jsx: <PWAUpdatePrompt />
 */
import { usePWA } from '@/hooks/usePWA'

export default function PWAUpdatePrompt() {
  const { updateAvailable, applyUpdate } = usePWA()

  if (!updateAvailable) return null

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '80px', // above bottom nav
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        background: '#1a1a1a',
        border: '1px solid #0e947a',
        borderRadius: '12px',
        padding: '0.75rem 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
        minWidth: '280px',
        maxWidth: '90vw',
      }}
    >
      <span style={{ fontSize: '1.2rem' }}>🔄</span>
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0, fontSize: '0.85rem', fontWeight: 600, color: '#f0f0f0' }}>
          Update Available
        </p>
        <p style={{ margin: 0, fontSize: '0.75rem', color: '#888' }}>
          A new version of the app is ready.
        </p>
      </div>
      <button
        onClick={applyUpdate}
        style={{
          background: '#0e947a',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '0.4rem 0.9rem',
          fontSize: '0.8rem',
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        Update
      </button>
    </div>
  )
}
